import { render, staticRenderFns } from "./OrderTypology.vue?vue&type=template&id=43f8e4b3&"
import script from "./OrderTypology.vue?vue&type=script&lang=js&"
export * from "./OrderTypology.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports